'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transitionEventName = exports.isEqual = undefined;

var _lodash = require('lodash.isequal');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Check whether the CSS property supported
 */
function isPropertySupported(name, value) {
  var propName = name;

  var element = document.createElement('p');
  document.body.insertBefore(element, null);

  element.style[propName] = value;

  var propValue = window.getComputedStyle(element, null).getPropertyValue(propName);

  document.body.removeChild(element);

  return propValue === value;
}

/*
 * Get CSS transitionend event name
 */
function transitionEventName() {
  if (isPropertySupported('transition', 'opacity 1s')) {
    return 'transitionend';
  }

  return 'webkitTransitionEnd';
}

exports.isEqual = _lodash2.default;
exports.transitionEventName = transitionEventName;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/animakit-expander/lib/utils.js
// module id = 309
// module chunks = 0